import { FunctionComponent } from "react";
import styled from "styled-components";

import { CXL, CXXL } from "@/components/Typography";
import { colours } from "@/utils";
import MarketingLink from "../MarketingLink";
import { Device } from "@/utils/device";

const FoundedContent: FunctionComponent = () => {
  return (
    <S.Section>
      <S.BoldText>Welcome to AllBright, </S.BoldText>
      <S.ItalicText>where ambition thrives</S.ItalicText>
      <S.BodyText>
        Founded in 2018 by Debbie Wosskow OBE and Anna Jones,
        <b>
          {" "}
          AllBright is the world’s largest collective of women in business,
          enabling ambition in all forms:{" "}
        </b>
        whether it’s building the confidence to lead a team meeting, or becoming
        CEO of a leading company.
        <br />
        <br />
        We support every woman, at every stage of their development,
        transforming leadership from the ground up, and supercharging businesses
        to be more equitable and inclusive.
      </S.BodyText>
      <MarketingLink linkText="Join AllBright" href="/memberships" />
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  margin: 2rem 10%;
  align-content: center;

  @media (min-width: ${Device.tablet}) {
    width: 52.5rem;
  }

  @media (min-width: ${Device.desktop}) {
    width: 75rem;
  }
`;

S.BoldText = styled(CXL)`
  color: ${colours.charcoal};
  font-weight: 800;
  display: inline;
`;

S.ItalicText = styled(CXL)`
  color: ${colours.charcoal};
  font-style: italic;
  font-weight: 100;
  display: inline;
`;

S.BodyText = styled(CXXL)`
  padding: 2rem 0 4rem 0;

  @media (min-width: ${Device.desktop}) {
    padding-bottom: 80px;
  }
`;

export default FoundedContent;
